import { generatePath, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AppRoutes } from '../pages/Routes'

interface AnnualPlanningNavigation {
  handleNavigateToContract: () => void
}

export const useAnnualPlanningNavigation = (): AnnualPlanningNavigation => {
  const { planId, rcnId, tab, planOrgId, planOrgTaskId } = useParams()
  const [searchParams] = useSearchParams()
  const nav = useNavigate()

  const activityQuery = searchParams.get('activity')

  const handleNavigateToContract = (): void => {
    let path = generatePath(
      AppRoutes.PLANNING_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY,
      {
        rcnId: rcnId ?? '',
        planId: planId ?? '',
        tab: tab ?? '',
        planOrgId: planOrgId ?? '',
        planOrgTaskId: planOrgTaskId ?? ''
      }
    )
    if (activityQuery != null) {
      path += `?activity=${activityQuery}`
    }
    nav(path)
  }

  return { handleNavigateToContract }
}
